import type { CrmMessages } from "./englishCrmMessages";

export const portuguesePwaMessages = {
  install_app: "Instalar app",
  install: "Instalar",
  dismiss: "Fechar",
  banner_title: "Instalar o %{name}",
  banner_body: "Adicione à tela inicial para abrir como um aplicativo.",
  ios_instructions:
    'Toque em Compartilhar e depois em "Adicionar à Tela de Início".',
  update_available: "Uma nova versão está disponível.",
  reload: "Recarregar",
} satisfies CrmMessages["crm"]["pwa"];
